module.exports = __webpack_public_path__ + "static/media/05_galeria_plantillas_combo_simple_rec_5.8def9d99.png";